import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//---------------------
// reduce markers count
//---------------------
export default function reduceMarkersCount(id) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  let idx = getCombatantIndexById(id);
  //---------------------
  // reduce marker count
  //---------------------
  combatants[idx].marker_count--;
}
